import { ExtraInfoValue, GroupedExtraInfo } from './types';
import { getConfiguration } from './configuration';

let extraInfoId = 1;

export const fromWireFormat = (groupedData: GroupedExtraInfo): ExtraInfoValue => {
  return {
    id: extraInfoId++,
    fieldId: groupedData?.extraInfoCodesValue?.id,
    fieldDesc: groupedData?.extraInfoCodesValue?.description,
    datatype: groupedData?.extraInfoCodesValue?.extraInfoDataType,
    searchRequired: groupedData?.extraInfoCodesValue?.searchRequired,
    categoryId: groupedData?.extraInfoCodesValue?.category,
    isHierarchy: groupedData?.extraInfoCodesValue?.isHierarchy,
    value: getConfiguration(groupedData?.extraInfoCodesValue?.extraInfoDataType)
      .toDataMapping(groupedData.initialValues)
  };
};
